import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { AdminRoute, ProtectedRoute } from "./auth/ProtectedRoute";
import { AppShell } from "./components/AppShell/AppShell";
import { Login } from "./pages/Login";
import { Overview } from "./pages/Overview";
import { Trades } from "./pages/Trades";
import { Logs } from "./pages/Logs";
import { Control } from "./pages/Control";
import { Users } from "./pages/Users";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<Overview />} />
                <Route path="/trades" element={<Trades />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/control" element={<Control />} />
                <Route element={<AdminRoute />}>
                  <Route path="/users" element={<Users />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
